module.exports = __webpack_public_path__ + "static/media/map.10cd4328.png";